import { useSelector } from 'react-redux'

import { UserProfile } from '@/types'
import { ReduxState } from '@/config/redux/types'

const selectUserProfile = (state: ReduxState): UserProfile => state.userProfile

const selectUserEmail = (state: ReduxState) => selectUserProfile(state).email
const selectUserId = (state: ReduxState) => selectUserProfile(state).id

const selectUserEligibility = (state: ReduxState): boolean =>
  !!state.userProfile.eligible

const selectUserExists = (state: ReduxState): boolean =>
  !!state.userProfile.userExists

const selectUserRegistrationCode = (state: ReduxState) =>
  selectUserProfile(state).registration_code?.[0]

const selectUserMembershipCode = (state: ReduxState) =>
  selectUserRegistrationCode(state)?.code

const selectUserUUID = (state: ReduxState) => selectUserProfile(state).uuid

const selectUserConsumerNetwork = (state: ReduxState) =>
  selectUserRegistrationCode(state)?.consumer_network

const useUserProfile = () => useSelector(selectUserProfile)
const useUserEmail = () => useSelector(selectUserEmail)
const useUserId = () => useSelector(selectUserId)
const useUserEligibility = () => useSelector(selectUserEligibility)
const useUserExists = () => useSelector(selectUserExists)

export {
  useUserProfile,
  selectUserProfile,
  useUserEligibility,
  selectUserRegistrationCode,
  selectUserMembershipCode,
  selectUserUUID,
  selectUserConsumerNetwork,
  useUserEmail,
  useUserId,
  useUserExists,
}
